import React from 'react';
import { Link } from 'react-router-dom';
import { getJobLine, getJobTagEn, getRomanName } from '../data/interviews';
import './InterviewCard.css';

const InterviewCard = ({ interview, compact = false }) => {
  const tag = getJobTagEn(interview);
  const content = (
    <>
      <div className="iv-card-thumb">
        {interview.thumbnail ? (
          <img
            src={interview.thumbnail}
            alt={`${interview.nameJa} ${interview.jobLabel || ''}`.trim()}
            loading="lazy"
          />
        ) : (
          <div className="iv-card-placeholder" aria-hidden="true" />
        )}
        {tag && <span className="iv-card-tag">{tag}</span>}
      </div>
      <div className="iv-card-body">
        <p className="iv-card-job">{getJobLine(interview)}</p>
        <h3 className="iv-card-name">
          {interview.nameJa}
          {interview.nameEn && <small>{getRomanName(interview)}</small>}
        </h3>
        {!compact && interview.catchCopy && (
          <p className="iv-card-copy">{interview.catchCopy}</p>
        )}
        {!interview.hasArticle && (
          <p className="iv-card-pending">記事準備中</p>
        )}
        {interview.hasArticle && <p className="iv-card-more">Read more →</p>}
      </div>
    </>
  );

  const className = `iv-card${compact ? ' iv-card-compact' : ''}${interview.hasArticle ? '' : ' iv-card-static'}`;

  if (!interview.hasArticle) {
    return <div className={className}>{content}</div>;
  }

  return (
    <Link
      to={`/interview/${interview.slug}`}
      className={className}
      onClick={() => {
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('event', 'click_interview_card', {
            job: interview.job,
            name: interview.nameJa
          });
        }
      }}
    >
      {content}
    </Link>
  );
};

export default InterviewCard;
